import * as React from 'react';
import { Grid } from '@material-ui/core';
import { tag } from '../../../model/tag';
import TextField from '../../../ui-components/TextField/TextField';
import Button from '../../../ui-components/Button/Button';
import { SearchBoxApi } from '../../../ui-components/SearchBoxApi/SearchBoxApi';
import NewItemButton from '../../../ui-components/Button/NewItemButton';
import { ActivityDefinition } from '../../../model/activities';

interface IProps {
    new: () => void;
    loading: boolean;
    allTags: tag[];
    allActivities: ActivityDefinition[];
    classes: any;
    search: (descr: string, tag: tag) => any;
}

const templateSearchBoxTag = (tag?: tag) => {
    return tag ? {
        label: (tag.code ? tag.code + " - " : "") + tag.description,
        value: tag
    } : undefined;
}

export const Filters = (props: IProps) => {
    const search = () => {
        props.search(description, tag);
    }
    const searchTags = (text: string, take?: number) => {
        let ret = props.allTags;
        if (props.allTags) {
            if (text)
                ret = props.allTags.filter(t => t.description.toLowerCase().indexOf(text.toLowerCase()) > -1)
        }
        //ret = props.allTags;
        return Promise.resolve(ret);
    }
    // const [filtered, setFiltered] = React.useState<ActivityDefinition[]>();
    const [description, setDescription] = React.useState('');
    const [tag, setTag] = React.useState<tag>();
    const { classes } = props;
    return (<Grid container xs={12} className={classes.root} spacing={2}>
        <Grid item xs={9} sm={8} >
            <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={6} >
                    <TextField label='Descrizione'
                        onKeyDown={(e) => {
                            //Enter KeyCode = 13
                            if (e.keyCode === 13) {
                                search()
                            }
                        }}
                        disabled={props.loading}
                        onChange={setDescription}
                        value={description} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SearchBoxApi<tag>
                        selectedItem={tag}
                        openOnFocus
                        doFilter
                        disabled={props.loading}
                        listSize={10}
                        onValueSubmit={search}
                        getItems={searchTags}
                        label={"Tag"}
                        placeholder={"Digitare descrizione o codice"}
                        templateItem={templateSearchBoxTag}
                        onSelectedChange={setTag} />
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={3} sm={4} className={classes.searchButtons} >
            <div className={classes.searchButton}>
                <Button className={classes.searchButton} onClick={search}>Cerca</Button>
            </div>
            <div className={classes.searchButton}>
                <NewItemButton disabled={props.loading} onClick={() => props.new()} text="Nuova" />
            </div>
        </Grid>
    </Grid>
    );
}